/*
Copyright 2026 WinSolutions

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

const SLOW_LOAD_NOTICE_DELAY_MS = 15_000;

window.__mxAppLoadStartedAt = Date.now();

const languages = navigator.languages?.length ? navigator.languages : [navigator.language ?? "en"];
const isRussian = languages.some((language) => language.toLowerCase().startsWith("ru"));

window.__mxSlowLoadNoticeText = isRussian
    ? "Загрузка занимает больше времени, чем обычно. Если вы используете VPN или прокси, попробуйте временно отключить его и обновить страницу."
    : "Loading is taking longer than usual. If you use a VPN or proxy, try temporarily disabling it and refreshing the page.";

window.setTimeout(() => {
    const slowNoticeNode = document.getElementById("mx_StaticPreload_notice");
    const preloader = document.getElementById("mx_StaticPreload");
    if (!slowNoticeNode || !preloader || !window.__mxSlowLoadNoticeText) return;

    // До старта React обновляем только статический preload-screen, после старта текст подхватит React.
    slowNoticeNode.textContent = window.__mxSlowLoadNoticeText;
    slowNoticeNode.hidden = false;
}, SLOW_LOAD_NOTICE_DELAY_MS);
